<template>
    <div class="unknown-stats-container">
      <div class="title-container">
        <v-icon icon="mdi-alert"></v-icon>
        <div class="title">
          Uh oh... {{ $t('i18n.alertMessage') }}
        </div>
      </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UnknownStats'
})
</script>

<style lang="scss" scoped>
.unknown-stats-container {
  padding: 1.0em 1.5em;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  justify-content: center;

  .title-container {
    align-self: center;
    justify-self: center;

    display: flex;
    align-items: center;

    .title {
      padding-left: 1em;
    }
  }
}
</style>
